<template>
  <div class="flex-grow-1 d-flex flex-column overflow-y-hidden">
    <div class="a-header">
      <span class="a-header--title slide-down-enter-active">
        View Blackout Periods
      </span>
      <a-button size="large" class="a-header--button slide-down-enter-active" type="primary" @click="onAdd">
        <img class="mr-2 icon-size" src="@assets/icon/plus.svg">
        Add New 
      </a-button>
    </div>
    <div v-if="isLoading" class="d-flex justify-content-center align-items-center pt-35-px">
      <Spinner />
    </div>
    <transition name="slide-up">
      <div v-if="!isLoading" class="a-filter">
        <a-row class="full-w" type="flex" justify="start" :gutter="16">
          <a-col :span="5">
            <div class="full-w a-input-group" :class="{ active: !!filterParams.search }">
              <a-button size="large">
                <a-icon type="search" />
              </a-button>
              <a-input class="custom-prefix" placeholder="Search Webpage URL" @change="onSearch" />
            </div>
          </a-col>
          <a-col :span="5">
            <div class="full-w a-select-group" :class="{ active: !!filterParams.status }">
              <a-button size="large">
                <a-icon type="filter" />
              </a-button>
              <a-select v-model="filterParams.status" :size="'large'" placeholder="Status" @change="onChangeStatus">
                <a-select-option v-for="status in statusList" :key="status">
                  {{ status }}
                </a-select-option>
              </a-select>
            </div>
          </a-col>
          <a-col :span="5">
            <div
              class="full-w a-input-group"
              :class="{
                active: !!filterParams.fromDate && !!filterParams.toDate,
              }"
            >
              <a-button size="large">
                <a-icon type="filter" />
              </a-button>
              <a-range-picker :ranges="RANGE" :placeholder="['From', 'To']" :format="DATE_FORMAT.DDMMMYYYY" @change="onChangeDate" />
            </div>
          </a-col>
        </a-row>
        <a-row class="full-w mt-2" type="flex" justify="start">
          <a-button size="default" :disabled="!isHasSelected" type="danger" class="danger-btn" @click="onDeletes()">
            <a-icon type="delete" />
            Delete Selected
          </a-button>
        </a-row>
      </div>
    </transition>
    <div v-resize="elSizeChange" class="a-body flex-grow-1 overflow-y-hidden">
      <transition name="slide-up">
        <template v-if="!isLoading">
          <PaginationTable
            :hasSelectRow="true"
            :pagination="pagin"
            :columns="BlackoutPeriodListColumn"
            :dataSource="filterData"
            :tableSize="tableSize"
            @changeSelectedRow="onSelectChange"
          >
            <div slot="urls" slot-scope="{ record }">
              <template v-for="item in record.urls">
                <a :key="item.id" :href="item.url" target="_blank" rel="noopener noreferrer" class="url text-wrap">
                  {{ item.url }}
                </a>
              </template>
            </div>
            <template slot="start" slot-scope="{ record }">
              <div>
                <p class="mb-0">
                  <time>{{ record.start | dateString }}</time>
                  <br>
                  <time>{{ record.start | timeString }}</time>
                </p>
              </div>
            </template>
            <template slot="end" slot-scope="{ record }">
              <div>
                <p class="mb-0">
                  <time>{{ record.end | dateString }}</time>
                  <br>
                  <time>{{ record.end | timeString }}</time>
                </p>
              </div>
            </template>
            <span slot="status" slot-scope="{ record }">
              <a-tag class="status" :class="getBlackoutStatusTagClass(record.status)">
                {{ record.status }}
              </a-tag>
            </span>
            <template slot="operation" slot-scope="{ record }">
              <a-dropdown placement="topLeft">
                <a-icon class="operation" type="ellipsis" />
                <a-menu slot="overlay" class="operation-menu">
                  <a-menu-item v-if="record.status !== 'Expired'" @click="onEdit(record)">
                    <a-icon type="edit" />Edit
                  </a-menu-item>
                  <a-menu-item>
                    <div class="full-wh" @click="showDeleteConfirm(record)">
                      <img class="mr-2" src="@assets/icon/delete.svg">
                      Delete
                    </div>
                  </a-menu-item>
                </a-menu>
              </a-dropdown>
            </template>
          </PaginationTable>
        </template>
      </transition>
    </div>
    <div class="a-footer">
      <PaginationBar :pageSize.sync="pagin.pageSize" :total="pagin.total" @change="paginChange" />
    </div>
  </div>
</template>

<script>
  const ALL_STATUS = 'All Status';
  const statusList = [ALL_STATUS, 'Awaiting', 'In Progress', 'Expired'];
  import moment from 'moment';

  import { DATE_FORMAT } from '@constants/dateFormat';
  import { RANGE } from '@constants/range';
  import { BlackoutPeriodListColumn } from '../columnsTable/BlackoutPeriodListColumn';
  import { getBlackoutStatusTagClass } from '../consts/BlackoutPeriod.consts';
  import BlackoutPeriodService from '../services/blackout-period.service';

  export default {
    name: 'BlackoutPeriodList',
    data() {
      let pageSize = Number(window.localStorage.getItem("pageSize"));
      if(!pageSize)
       pageSize = 5;

      return {
        ALL_STATUS,
        RANGE,
        DATE_FORMAT,
        statusList,
        BlackoutPeriodListColumn,
        data: [],
        filterData: [],
        selectedRowKeys: [],
        pagin: {
          current: 1,
          pageSize: pageSize,
          total: 0,
        },
        filterParams: {
          search: '',
          status: ALL_STATUS,
          fromDate: null,
          toDate: null,
        },
        isLoading: true,
        tableSize: {
          height: '',
          width: '',
        },
      };
    },
    computed: {
      isHasSelected() {
        return this.selectedRowKeys.length > 0;
      },
    },
    mounted() {
      this.getList();
    },
    methods: {
      getBlackoutStatusTagClass,

      getPeriodRowId(record, index) {
        return `${record.start}|${record.end}|${index}`;
      },

      normalizeBlackoutPeriodRow(record, index) {
        const id = this.getPeriodRowId(record, index);
        return {
          ...record,
          id,
          isChecked: false,
        };
      },

      filter() {
        const searchTerm = this.filterParams.search;
        const filterDataBySearchUrl = searchTerm
          ? this.data.filter(item => {
              const urlNames = (item.urls || []).map(urlItem => urlItem.url);
              return urlNames.some(urlName => urlName.includes(searchTerm));
            })
          : this.data;
        const filterDataByStatus = this.filterParams.status && this.filterParams.status !== ALL_STATUS ? filterDataBySearchUrl.filter(item => item.status === this.filterParams.status) : filterDataBySearchUrl;
        const filterDataByFromDate = this.filterParams.fromDate ? filterDataByStatus.filter(item => moment(item.start).isSameOrAfter(moment(this.filterParams.fromDate))) : filterDataByStatus;
        const filterDataByToDate = this.filterParams.toDate ? filterDataByFromDate.filter(item => moment(item.end).isSameOrBefore(moment(this.filterParams.toDate))) : filterDataByFromDate;
        this.filterData = filterDataByToDate;
        this.pagin = {
          current: 1,
          pageSize: this.pagin.pageSize,
          total: filterDataByToDate.length,
        };
      },

      onSearch(event) {
        this.filterParams.search = (event.target.value && String(event.target.value).trim().toLowerCase()) || '';
        this.filter();
      },
      onChangeStatus(value) {
        this.filterParams.status = value;
        this.filter();
      },
      onChangeDate(dates, dateStrings) {
        this.filterParams.fromDate = new Date(dateStrings[0]).setHours(0, 0, 0, 1);
        this.filterParams.toDate = new Date(dateStrings[1]).setHours(23, 59, 59, 59);
        this.filter();
      },
      onDelete(record) {
        BlackoutPeriodService.delete(record.start, record.end).then(() => {
          this.$showSuccessMessage('Deleted Blackout period');
          this.getList();
        });
      },
      onEdit(record) {
        this.$router.push({
          path: 'edit',
          query: { start: encodeURIComponent(record.start), end: encodeURIComponent(record.end) },
        });
      },
      onSelectChange(selectedRowKeys) {
        this.selectedRowKeys = selectedRowKeys;
      },
      paginChange(pagin) {
        this.pagin = { ...pagin };
      },
      onAdd() {
        this.$router.push('/blackout-periods/add');
      },
      async getList() {
        try {
          const data = await BlackoutPeriodService.getList();
          const rows = (data || []).map((item, index) => this.normalizeBlackoutPeriodRow(item, index));
          const validRowIds = new Set(rows.map((item) => item.id));
          this.selectedRowKeys = this.selectedRowKeys.filter((key) => validRowIds.has(key));
          this.data = rows;
          this.filter();
        } catch {
          this.$showErrorMessage('HTTP error received from web server.!');
        } finally {
          if (this.isLoading) {
            setTimeout(() => {
              this.isLoading = false;
            }, 300);
          }
        }
      },
      showDeleteConfirm(record) {
        this.$confirm({
          title: 'Are you sure delete this item?',
          okText: 'Yes',
          okType: 'danger',
          cancelText: 'No',
          onOk: () => {
            this.onDelete(record);
          },
        });
      },
      onDeletes() {
        const selectedRecords = this.data.filter((item) => this.selectedRowKeys.includes(item.id));
        const selectedCount = selectedRecords.length;
        if (!selectedCount) return;

        this.$confirm({
          title: `Are you sure to delete the ${selectedCount} blackout period(s)?`,
          okText: 'Yes',
          okType: 'danger',
          cancelText: 'No',
          onOk: async () => {
            try {
              const periodKeys = new Set();
              const periods = selectedRecords.reduce((acc, { start, end }) => {
                const key = `${start}|${end}`;
                if (!periodKeys.has(key)) {
                  periodKeys.add(key);
                  acc.push({ start, end });
                }
                return acc;
              }, []);
              const response = await BlackoutPeriodService.batchDelete({ periods });
              this.$showSuccessMessage((response && response.message) || `${selectedCount} blackout period(s) deleted successfully`);
              this.selectedRowKeys = [];
              await this.getList();
            } catch {
              this.$showErrorMessage('Failed to delete blackout periods. Please try again.');
            }
          },
        });
      },
      elSizeChange(size) {
        this.tableSize = size;
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '../styles/blackout-status-tags';

  .a-body {
    height: calc(100% - 255px);
  }
  .a-filter {
    height: auto;
  }

  .url {
    display: block;
  }
</style>
